import { Navigate, useParams } from "react-router-dom";
import { SubPage } from "../components/common";
import { LegalLinks } from "../components/LegalLinks";
import { useLang } from "../lib/i18n";
import { LEGAL, LEGAL_UPDATED } from "../lib/legal";

const Para = ({ items }) => items?.map((p, i) => <p key={i} className="mt-2 text-[15px] leading-relaxed text-slate-700">{p}</p>);

export default function LegalPage() {
  const { slug } = useParams();
  const { lang, t } = useLang();
  const doc = (LEGAL[lang] || LEGAL.es)[slug];
  if (!doc) return <Navigate to="/" replace />;
  return (
    <SubPage title={doc.title} testid={`legal-page-${slug}`}>
      <article className="rounded-3xl bg-white px-5 py-6 shadow-[0_4px_20px_rgba(13,42,107,0.06)] sm:px-8">
        <p className="text-xs text-slate-400" data-testid="legal-updated">{t("legal.updated", { date: LEGAL_UPDATED[lang] || LEGAL_UPDATED.es })}</p>
        <h1 className="mt-2 font-serif text-3xl font-extrabold text-navy" data-testid="legal-title">{doc.title}</h1>
        {doc.sections.map((s) => (
          <section key={s.h} className="mt-7">
            <h2 className="text-lg font-extrabold text-navy">{s.h}</h2>
            <Para items={s.p} />
            {s.list && (
              <ul className="mt-2 list-disc space-y-1.5 pl-5 text-[15px] leading-relaxed text-slate-700 marker:text-brand">
                {s.list.map((li) => <li key={li}>{li}</li>)}
              </ul>
            )}
            <Para items={s.p2} />
          </section>
        ))}
      </article>
      <LegalLinks className="mt-6" testid="legal-page-links" />
    </SubPage>
  );
}
